export default __webpack_public_path__ + "66c81495cbb3e3109f794e153cc0c0c6.jpg";